import { produce, Draft } from 'immer'
import { TActionTypes } from '@Root/types'

import {
  ISubtitleState,
  SubtitleActionTypes,
} from './types'

export const initialState: ISubtitleState = {
  importingSrt: false
}

type TAction = TActionTypes

export const subtitlesReducer = (
  state: ISubtitleState = initialState,
  action: TAction
): ISubtitleState => {
  return produce(state, draft => {
    switch (action.type) {
      case SubtitleActionTypes.IMPORT_SRT:
        setImportingSrt(draft)
        break

      case SubtitleActionTypes.IMPORT_SRT_SUCCESS:
      case SubtitleActionTypes.IMPORT_SRT_FAILURE:
        resetImportingSrt(draft)
        break

      default:
        break
    }
  })
}

const setImportingSrt = (draft: Draft<ISubtitleState>) => {
  draft.importingSrt = true
}

const resetImportingSrt = (draft: Draft<ISubtitleState>) => {
  draft.importingSrt = false
}
